/* global axios */
import ApiClient from './ApiClient';

class FollowUpCadenceRunsAPI extends ApiClient {
  constructor() {
    super('follow-up-cadence-runs', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  // Quantas execuções há em cada status, na conta inteira (faixa do Painel).
  contagem() {
    return axios.get(`${this.url}/contagem`);
  }

  // O que sai, quando e para quem nos próximos 14 dias (24/10/2026).
  agenda() {
    return axios.get(`${this.url}/agenda`);
  }

  // `startOn` ('YYYY-MM-DD', opcional) agenda a cadência pra esse dia em vez
  // de começar agora — pedido da Dra. Jullya (07/09/2026).
  create({ conversationId, followUpCadenceDefinitionId, startOn, mesmoAssim }) {
    return axios.post(this.url, {
      conversation_id: conversationId,
      // A pessoa viu os avisos (lead frio etc.) e decidiu colocar mesmo assim (20/10/2026).
      ...(mesmoAssim ? { mesmo_assim: true } : {}),
      ...(followUpCadenceDefinitionId
        ? { follow_up_cadence_definition_id: followUpCadenceDefinitionId }
        : {}),
      ...(startOn ? { start_on: startOn } : {}),
    });
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  approveStep(id, content) {
    return axios.post(
      `${this.url}/${id}/approve_step`,
      content ? { content } : {}
    );
  }

  rejectStep(id) {
    return axios.post(`${this.url}/${id}/reject_step`);
  }

  regenerateStep(id) {
    return axios.post(`${this.url}/${id}/regenerate_step`);
  }
}

export default new FollowUpCadenceRunsAPI();
